import React, { useState } from 'react';
import { Modal, Tabs, Tab } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { formatMessage } from '../../../translations/connectedIntlProvider';
import ChangePasswordPopup from './ChangePasswordPopup'; 
import Settings from './Components/Settings';
import "./UserProfile.css"
  
interface IProps {
    id:string;
    userName:string;
    userType:string;
    onModalClosed: () => void;
}

const UserProfile: React.FC<IProps> = (props) => {
    const ControlledTabs = () => {
        const [key, setKey] = useState<string>('Settings');
      
        return (
        <div className="user-profile-popup">
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k:any) => setKey(k)}
            className="modal-body pb-0">
            <Tab eventKey="Settings" title={formatMessage("Settings")}>
               <Settings modalClosed ={props.onModalClosed}/>
            </Tab>
            {   props.userName !== "admin@test.com" &&
                <Tab eventKey="Password" title={formatMessage("Title_Change_Password")}>
                <ChangePasswordPopup
                    id={props.id}
                    modalClosed ={props.onModalClosed}
               />
                </Tab>
            }
          </Tabs>
        </div>
        );
    }

    return (
        <Modal className="add-user-modal device-pop-up" show={true} centered onHide={props.onModalClosed}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage id='User_Profile' />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
                <div className="modal-body">
                    <div className="row">     
                        <div className={"col-md-12 mb-2"}>
                            <div className="bootbox-body user-details">
                                <i className="fa fa-user float-left"></i>
                                <span className="float-left">
                                    <b>{props.userName}</b> <br/>
                                    {props.userType}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <ControlledTabs />
            </Modal.Body>
        </Modal>
    )
}
 
export default UserProfile;
